export { default } from '../../media/[id]';
